import { Bitter, Yellowtail, Lexend } from 'next/font/google';

const bitter = Bitter({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-bitter',
  weight: ['400', '700'],
});

const yellowtail = Yellowtail({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-yellowtail',
  weight: ['400'],
});

const lexend = Lexend({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-lexend',
  weight: ['400', '700'],
});

export const supportedFonts = [bitter, yellowtail, lexend];
